"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var spacing = _ref.spacing;
  return {
    headerCell: {
      fontSize: '0.75rem',
      lineHeight: 1.33,
      paddingTop: spacing(3),
      paddingBottom: spacing(1)
    },
    checkboxCell: {
      paddingLeft: 0,
      paddingRight: 0
    }
  };
});

var TableHeadRow = function TableHeadRow(_ref2) {
  var columns = _ref2.columns,
      _ref2$sort = _ref2.sort,
      sort = _ref2$sort === void 0 ? {
    column: 'id',
    direction: 'asc'
  } : _ref2$sort,
      _ref2$onChangeSort = _ref2.onChangeSort,
      onChangeSort = _ref2$onChangeSort === void 0 ? function () {
    return undefined;
  } : _ref2$onChangeSort,
      isSelectable = _ref2.isSelectable;
  var classes = useStyles();
  var handleChangeSort = (0, _react.useCallback)(function (column) {
    if (!column.hideSorting) {
      onChangeSort({
        column: column,
        direction: sort.column === column && sort.direction === 'desc' ? 'asc' : 'desc'
      });
    }
  }, [onChangeSort, sort]);
  return /*#__PURE__*/_react["default"].createElement(_material.TableRow, null, isSelectable && /*#__PURE__*/_react["default"].createElement(_material.TableCell, {
    className: (0, _classnames["default"])(classes.headerCell, classes.checkboxCell)
  }), columns.map(function (_ref3, i) {
    var id = _ref3.id,
        name = _ref3.name,
        align = _ref3.align,
        isEmpty = _ref3.isEmpty,
        hideSorting = _ref3.hideSorting;

    if (isEmpty) {
      return /*#__PURE__*/_react["default"].createElement(_material.TableCell, {
        className: classes.headerCell,
        key: String(i)
      });
    }

    if (!isEmpty && hideSorting) {
      return /*#__PURE__*/_react["default"].createElement(_material.TableCell, {
        align: align,
        className: classes.headerCell,
        key: id
      }, name);
    }

    return /*#__PURE__*/_react["default"].createElement(_material.TableCell, {
      align: align,
      className: classes.headerCell,
      key: id
    }, /*#__PURE__*/_react["default"].createElement(_material.TableSortLabel, {
      direction: sort.column === id ? sort.direction : 'asc',
      active: sort.column === id,
      onClick: function onClick() {
        return handleChangeSort(id);
      }
    }, name));
  }));
};

var _default = /*#__PURE__*/(0, _react.memo)(TableHeadRow);

exports["default"] = _default;